import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=js"

import "./UserAvatar.vue?vue&type=style&index=0&id=e0f84d4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0f84d4a"]])

export default __exports__